import VDMDashboardBunker from "components/app/vdmdashboard/bunker-robs/VDMDashboardBunker";
import React from "react";

type ScreenVDMDashboardBunkerType = React.PropsWithChildren<{
	match: {
		params: {
			vesselId: string;
		};
	};
}>;
const ScreenVDMDashboardBunker: React.FC<ScreenVDMDashboardBunkerType> = (
	props: ScreenVDMDashboardBunkerType
) => {
	return <VDMDashboardBunker vesselId={props.match.params.vesselId} />;
};

export default ScreenVDMDashboardBunker;
